import React from 'react';
import { Styles } from '@t2c/shared-fe';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { CustomDialogContainer, CustomDialogTitle } from '../../Common/dialog';
import { CircularProgress } from '@mui/material';
import { Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { getErrorMsgForAiMediaGeneration } from 'apps/t2c-fe/utils';

interface Props {
  shouldOpenDialog: boolean;
  handleCloseDialog: () => void;
  error: string | null;
}

export const MusicProccessingModal: React.FC<Props> = ({
  shouldOpenDialog,
  handleCloseDialog,
  error,
}) => {
  return (
    <CustomDialogContainer open={shouldOpenDialog} maxWidth="sm">
      <CustomDialogTitle sx={styles.title} title={'Generating Music'} onClose={handleCloseDialog} />
      <DialogContent dividers sx={styles.dialogContent}>
        <>
          {!error && (
            <Stack sx={styles.loading}>
              <Typography fontWeight={600} fontSize={'26px'}>
                Hold on tight! We’re Generating AI Music.
              </Typography>
              <CircularProgress />
              {/* <Typography fontSize={12}>
                Estimated Time: <b>1 Minute</b>
              </Typography> */}
            </Stack>
          )}

          {error && (
            <Box sx={styles.errContainer}>
              <Typography sx={styles.errHeading} textAlign={'center'}>
                Oops!
              </Typography>
              <ErrorOutlineIcon sx={{ width: 75, height: 75 }} color="error" />
              <Typography sx={{ color: (theme) => theme.palette.text.error }}>
                {getErrorMsgForAiMediaGeneration(
                  error,
                  'Failed to generate your music. Please try again'
                )}
              </Typography>
            </Box>
          )}
        </>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 2 }}>
        {error && (
          <Button variant="outlined" sx={styles.cancelBtn} onClick={handleCloseDialog}>
            Close
          </Button>
        )}
      </Box>
    </CustomDialogContainer>
  );
};

const styles: Styles = {
  title: {
    paddingBottom: '10px',
    paddingTop: '10px',
  },
  subTitle: {
    fontSize: '26px',
    fontWeight: 600,
  },
  dialogContent: {
    padding: '24px',
    backgroundColor: (theme) => theme.palette.background.secondary,
  },
  textField: {
    background: (theme) => theme.palette.common.white,
  },
  saveBtn: {
    color: (theme) => theme.palette.common.white,
    boxShadow: 'none',
    minWidth: 150,
  },
  cancelBtn: {
    width: 200,
  },
  promptExamples: {
    fontSize: '14px',
    lineHeight: 2.2,
    color: (theme) => theme.palette.text.secondary,
  },
  promptExamplesContainer: {
    backgroundColor: (theme) => theme.palette.background.note,
    borderRadius: '6px',
    padding: 1,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: 4,
    gap: 2,
  },

  errContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 3,
    textAlign: 'center',
  },
  errHeading: { fontSize: '26px', fontWeight: 600 },
};
